import {Account, LocationDetails, Locations,Checkin} from './views';

export default [
    {
        path: "/account",
        name: "Account settings",
        component: Account,
        meta: {
            authGuard: (user) => user != null
        }
    },
    {
        path: "/checkin",
        name: "Checkin",
        component: Checkin,
        meta: {
            authGuard: (user) => user != null
        }
    },
    {
        path: "/locations",
        name: "locationsList",
        component: Locations,
        meta: {
            authGuard: (user) => user.isClient
        }
    },
    {
        path: "/locations/:id",
        name: "locationDetails",
        component: LocationDetails,
        meta: {
            authGuard: (user) => user.isClient
        }
    }
];
